import type { TourDefinition, TourWelcomeFeature } from "./types";

type WelcomeFeature = Pick<TourWelcomeFeature, "key" | "Icon"> & {
  descriptionPart: "description" | "descriptionReadonly";
};

export function getWelcomeFeatures(definition: TourDefinition, stepIds: string[]): WelcomeFeature[] {
  return definition.welcomeFeatures
    .filter(({ requiresStep }) => !requiresStep || stepIds.includes(requiresStep))
    .map(({ key, Icon, fullDescriptionStep }) => ({
      key,
      Icon,
      descriptionPart: fullDescriptionStep && !stepIds.includes(fullDescriptionStep) ? "descriptionReadonly" : "description",
    }));
}
